import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";


import { 
  getAllUsers as getAllUsersApi,
  userSignup as userSignupApi,
  userCheckout as userCheckoutApi,
  getPaymentPlans as getPaymentPlansApi,
  getUserProfile as getUserProfileApi,
  getMyParticipatedContests as getMyParticipatedContestsApi,
  getAdminStat as getAdminStatApi,
  getUserSubscribePlanRevenue as getUserSubscribePlanRevenueApi,
  getEventEarning as getEventEarningApi,
  getAdminRevenue as getAdminRevenueApi,
  getUserRewardsApi as getUserRewardsApi,

 } from "../../helpers/custom_helper/backend_helper";


 export const getUserList = createAsyncThunk("get-all-users", async () => {
  try {
   
     const response = getAllUsersApi();
    const data = await response;
  
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});
export const signupUserThunk = createAsyncThunk( "userSignup",async (userData, { rejectWithValue }) => {
    try {

      const response = await userSignupApi(userData);
    
   
      if (response.success) {
        if(response.data.accessToken){
          const expiryTime = new Date().getTime() + 12 * 60 * 60 * 1000; // 12 hours
         localStorage.setItem("authToken", response.data.accessToken);
        localStorage.setItem("authUser", JSON.stringify(response.data));
        localStorage.setItem("authExpiry", expiryTime); 
        localStorage.setItem('authVersion', Date.now());
        
        }
        return response.data;
      } else {
        toast.error(response.message || "Login failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);
export const userCheckoutThunk = createAsyncThunk( "userCheckout",async (userData, { rejectWithValue }) => {
    try {

      const response = await userCheckoutApi(userData);

      // console.log("response");
      // console.log(response);
      
      if (response.success) {
        
        const expiryTime = new Date().getTime() + 12 * 60 * 60 * 1000; // 12 hours
         localStorage.setItem("authToken", response.data.accessToken);
        localStorage.setItem("authUser", JSON.stringify(response.data));
        localStorage.setItem("authExpiry", expiryTime); 
        localStorage.setItem('authVersion', Date.now());
        return response.data;
      } else {
        toast.error(response.message || "Login failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);

 export const getPaymentPlanThunk = createAsyncThunk("payment-plan-list", async (postData) => {
  try {

     const response = getPaymentPlansApi(postData);
      const data = await response;
     
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});


 export const getUserProfileThunk = createAsyncThunk("get-user-profile", async (userData) => {
  try {
    
     const response = getUserProfileApi(userData);
     const data = await response;
    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});

 export const getMyParticipatedContestsThunk = createAsyncThunk("get-participated-contest", async (userData) => {
  try {
    
     const response = getMyParticipatedContestsApi(userData);
     const data = await response;

    // Remove duplicate objects based on contest_id
data.data = data.data.filter(
  (item, index, self) =>
    index === self.findIndex(obj => obj.contest_id_without_encrypt == item.contest_id_without_encrypt)
);

// console.log("data");
// console.log(data);
  
    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});


//admin stat
 export const getAdminStatThunk = createAsyncThunk("get-admin-stat", async () => {
  try {
     const response = getAdminStatApi();
     const data = await response;

    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});

//user subscribe plan
 export const getUserSubscribePlanThunk = createAsyncThunk("get-user-subscribe-plan", async (postData) => {
  try {
     const response = getUserSubscribePlanRevenueApi(postData);
     const data = await response;

    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});

 export const getAdminRevenueThunk = createAsyncThunk("get-admin-revenue", async () => {
  try {
     const response = getAdminRevenueApi();
     const data = await response;


    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});
 export const getEventEarningThunk = createAsyncThunk("get-event-earning", async (dataa) => {
  try {
     const response = getEventEarningApi(dataa);
     const data = await response;


    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});
 export const getUserRewardsThunk = createAsyncThunk("get-user-rewards", async (dataa) => {
  try {
     const response = getUserRewardsApi(dataa);
     const data = await response;


    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
       toast.error(error);
      return error;
  }
});















